import * as React from "react";

import { useGetSvgIconFill } from "@intelligems/ig-theme";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const CodeBlocks = (props: SvgIconProps) => {
  const fill = useGetSvgIconFill(props.color);

  return (
    <SvgIcon {...props}>
      <svg
        width={35}
        height={35}
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect width={35} height={35} rx={5} fill="white" />
        <rect width={35} height={35} rx={5} fill={fill} fillOpacity={0.08} />

        <g mask="url(#mask0_60218_102000)">
          <path
            d="M15.1 21.1L16.5 19.675L14.325 17.5L16.5 15.325L15.1 13.9L11.5 17.5L15.1 21.1ZM19.9 21.1L23.5 17.5L19.9 13.9L18.5 15.325L20.675 17.5L18.5 19.675L19.9 21.1ZM10.5 26.5C9.95 26.5 9.47917 26.3042 9.0875 25.9125C8.69583 25.5208 8.5 25.05 8.5 24.5V10.5C8.5 9.95 8.69583 9.47917 9.0875 9.0875C9.47917 8.69583 9.95 8.5 10.5 8.5H24.5C25.05 8.5 25.5208 8.69583 25.9125 9.0875C26.3042 9.47917 26.5 9.95 26.5 10.5V24.5C26.5 25.05 26.3042 25.5208 25.9125 25.9125C25.5208 26.3042 25.05 26.5 24.5 26.5H10.5ZM10.5 24.5H24.5V10.5H10.5V24.5Z"
            fill={fill}
            fillOpacity={0.38}
          />
        </g>
      </svg>
    </SvgIcon>
  );
};
